// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { i18n } from './plugins/i18n.js'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/gotop.css'

import router from './router'
import './ml'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas, faUserSecret, faCheck, faSpinner, faHome } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import * as VueGoogleMaps from 'vue2-google-maps'
import axios from 'axios'

Vue.use(BootstrapVue)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB7xkEvT-T-YRL6-hxbzG_sMqVk0H7bZXc',
    libraries: 'places'
  }
})

library.add(fas)
library.add(faUserSecret)
library.add(faCheck)
library.add(faSpinner)
library.add(faHome)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.prototype.$http = axios
Vue.prototype.$lang = 'english'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js